<div class="container">
  <h2>Update Device Status</h2>
  <div>
    <table mat-table [dataSource]="devices" multiTemplateDataRows>
      <ng-container matColumnDef="Status">
        <th mat-header-cell *matHeaderCellDef> Status</th>
        <td mat-cell *matCellDef="let device">
          @if (device.Status == teltonikaStates.success) {
            <mat-icon style="color:forestgreen"
                      [matTooltip]="'Success'">check_circle
            </mat-icon>
          } @else if (device.Status == teltonikaStates.failure) {
            <mat-icon style="color:crimson" [matTooltip]="'Failed'">cancel</mat-icon>
          } @else if (device.Status == teltonikaStates.loading) {
            <mat-spinner [diameter]="40"></mat-spinner>
          } @else {
            <mat-icon style="color:orange" [matTooltip]="'Cancelled'">cancel</mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="DeviceIP">
        <th mat-header-cell *matHeaderCellDef> Device IP</th>
        <td mat-cell *matCellDef="let device"> {{ device.IP }}</td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
          <div class="example-element-detail"
               [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
            <div class="example-element-description">
              @for (response of element.Responses; track response; let i = $index) {
                <div class="responses">
                  @if (response.Message != null) {
                    <div [ngClass]="{'inline-data':true}">
                      <div><b>Response Message: </b></div>
                      <div>{{ response.Message }}</div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
      <tr mat-row *matRowDef="let device;columns: columnsToDisplay"
          [class.example-expanded-row]="expandedElement === device" (click)="expand(device)">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
    </table>

    <div class="buttons">
      <button mat-raised-button [disabled]="!csv"
              (click)="exportCSV(csv, 'UpdateDevicesResult_' + user + '_'+dateString+'.csv')">
        Export CSV
        <mat-icon>download</mat-icon>
      </button>
    </div>

    <div class="buttons">
      <button mat-raised-button (click)="close()">Exit
        <mat-icon>logout</mat-icon>
      </button>
    </div>
  </div>
</div>
